






























































































import Vue from "vue";
import store from "@/store";
import { AxiosResponse } from "axios";
// api
import * as reportApi from "@/features/analytics/axios";
// component
import PageTitle from "@/commons/components/PageTitle.vue";
import DialogCard from "@/commons/components/DialogCard.vue";
// enum
import { ReportTypeEnum } from "@/features/analytics/enums/ReportType";
// types
import { DataTableHeader } from "vuetify/types";
import { LoginUser } from "@/commons/types";
import { ReportForTable, GetReportsResponse } from "@/features/analytics/types";
// util
import * as notifyUtil from "@/commons/utils/notifyUtil";

export default Vue.extend({
  components: {
    "page-title": PageTitle,
    "dialog-card": DialogCard,
  },
  created() {
    // ログインユーザーの情報取得
    this.loginUser = store.getters["auth/getLoginUser"];
    // レポート一覧取得
    this.fetchData();
  },
  data() {
    return {
      loginUser: null as LoginUser | null,
      dialog: false as boolean,
      reports: [] as ReportForTable[],
      deleteTargetReport: undefined as ReportForTable | undefined,
      deleteTargetReportName: "" as string,
      loading: true as boolean,
      searchValue: "" as string,
      formSearchValue: "" as string,
      index: 1 as number,
    };
  },
  computed: {
    reportTableHeaders(): DataTableHeader[] {
      return [
        {
          text: String(this.$t("analytics.tableHeader.name")),
          value: "name",
          width: "44%",
        },
        {
          text: String(this.$t("analytics.tableHeader.owner")),
          value: "owner",
          width: "20%",
        },
        {
          text: String(this.$t("analytics.tableHeader.reportType")),
          value: "type",
          width: "20%",
        },
        {
          text: String(this.$t("analytics.tableHeader.createdAt")),
          value: "createdAt",
          width: "15%",
        },
        {
          text: "",
          value: "action",
          align: "end",
          width: "1%",
          sortable: false,
        },
      ];
    },
  },
  methods: {
    clickNewReport() {
      this.$router.push({ name: "NewReport" });
    },
    editReport(item: ReportForTable) {
      this.$router.push({
        name: "EditReport",
        params: { reportId: String(item.id) },
      });
    },
    async clickOkOnDialog() {
      // loading状態にする
      this.loading = true;

      await reportApi
        .deleteReport(this.deleteTargetReport?.id)
        .then(() => {
          notifyUtil.notifySuccessMessage(this.$t("analytics.notify.success.delete"));
          // レポート一覧取得APIを叩き、データを最新の状態にする
          this.fetchData();
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("analytics.notify.error.delete"));
          }
        })
        .finally(() => {
          this.deleteTargetReport = undefined;
          this.dialog = false;
          this.loading = false;
        });
    },
    clickCancelOnDialog() {
      this.dialog = false;
      this.deleteTargetReport = undefined;
      this.deleteTargetReportName = "";
    },
    clickDelete(report: ReportForTable) {
      this.dialog = true;
      this.deleteTargetReport = report;
      this.deleteTargetReportName = report.name;
    },
    canDeleteReport(email: string): boolean {
      return this.loginUser?.email === email;
    },
    async fetchData() {
      // loading状態にする
      this.loading = true;

      await reportApi
        .getReports()
        .then((response: AxiosResponse<GetReportsResponse>) => {
          this.reports = response.data.reports.map(element => {
            let ownerValue = "" as string;
            if (element.owner.name) {
              ownerValue = element.owner.name;
            } else {
              ownerValue = element.owner.email;
            }
            const report = {
              id: element.reportId,
              name: element.reportName,
              owner: ownerValue,
              email: element.owner.email,
              type: ReportTypeEnum.getByValue(element.reportType)?.text,
              createdAt: this.convertDisplayDatetime(element.createdAt),
              rawCreatedAt: element.createdAt,
            };
            return report;
          });
        })
        .catch(error => {
          if (error.response.status === 401) {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.sessionExpired"));
            this.$router.push({ name: "Login" });
          } else {
            notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.analyticsReport"));
          }
        });

      // 全てのデータが更新された時点でloading完了
      this.loading = false;
    },

    convertDisplayDatetime(datetime: string) {
      // safari用にハイフンをスラッシュに変換
      const escapedDatetime = datetime.replace(/-/g, "/");
      const convertDatetime = new Date(escapedDatetime) as Date;
      // DBはUTCなのでJSTに調整
      convertDatetime.setHours(convertDatetime.getHours() + 9);

      let displayDatetime = "" as string;
      // 24時間以内か確認
      const now = new Date();
      if ((now.getTime() - convertDatetime.getTime()) / (24 * 60 * 60 * 1000) <= 1) {
        // 1時間以内であれば分刻み、そうでなければ時間刻み
        if ((now.getTime() - convertDatetime.getTime()) / (60 * 60 * 1000) <= 1) {
          const minutesDiff = (now.getTime() - convertDatetime.getTime()) / (60 * 1000);
          displayDatetime = Math.floor(minutesDiff) + " Minutes ago";
        } else {
          const hourDiff = (now.getTime() - convertDatetime.getTime()) / (60 * 60 * 1000);
          displayDatetime = Math.floor(hourDiff) + " Hours ago";
        }
      } else {
        // ex)Wed Sep 22 2021
        displayDatetime = convertDatetime.toDateString().substring(4);
      }
      return displayDatetime;
    },

    reportsFilter(
      value: string | undefined | null,
      search: string | null,
      item: ReportForTable
    ): boolean {
      return value != null && search != null && item.name.includes(search);
    },
    execSearch() {
      this.index = 1;
      this.searchValue = this.formSearchValue;
    },
    clearSearch() {
      this.index = 1;
      this.searchValue = "";
    },
    customSort(items: ReportForTable[], index: string[], isDesc: boolean[]): ReportForTable[] {
      items.sort((a: any, b: any) => {
        if (index[0] === "createdAt") {
          const dateA = new Date(a.rawCreatedAt.replace(/-/g, "/"));
          const dateB = new Date(b.rawCreatedAt.replace(/-/g, "/"));
          if (!isDesc[0]) {
            return dateB < dateA ? 1 : -1;
          } else {
            return dateB > dateA ? 1 : -1;
          }
        } else {
          if (typeof a[index[0]] !== "undefined") {
            if (!isDesc[0]) {
              return a[index[0]].localeCompare(b[index[0]]);
            } else {
              return b[index[0]].localeCompare(a[index[0]]);
            }
          }
        }
      });
      return items;
    },
  },
});
